<template>
  <splash>
    <template v-slot:splash-content>

  <v-container>
    <v-layout align-center justify-center column>
      <v-flex xs12 sm8 md4>
        <v-card class="elevation-12">
          <v-toolbar color="primary">
            <v-toolbar-title>Login with your FilmID password</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-form>
              <div class="text-xs-right caption">
                <a v-if="!forgotDisabled" @click="forgotPassword"><span class="caption">forgot password</span></a>
                <span  class="pl-5">
                  <router-link to="/signup">Sign up</router-link>
                </span>
              </div>
              <v-text-field type="text" single-line prepend-icon="person" class="pa-0" v-model="email" :rules="emailRules" name="email"></v-text-field>
              <v-text-field single-line prepend-icon="lock" label="filmID password" type="password" v-model="password" name="password"></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions class="justify-center">
            <v-btn color="primary" @click="loginClick" :disabled="loginDisabled">Login</v-btn>
            <v-btn color="secondary" @click="cancelClick">Cancel</v-btn>
          </v-card-actions>
          <v-card-text>
            <div class="text-xs-center">Additional login options</div>
          </v-card-text>
          <v-card-actions class="justify-center">
            <v-btn icon><img :src="buttonGoogle" height="24px" width="24px" @click="loginGoogle"></v-btn>
            <v-btn icon><img :src="buttonGithub" height="24px" width="24px" @click="loginGithub"></v-btn>
            <v-btn icon><img :src="buttonTwitter" height="24px" width="24px" @click="loginTwitter"></v-btn>
          </v-card-actions>
      </v-card>

      <v-card v-if="showForgotDialog">
        <v-toolbar light color="accent">
          <v-toolbar-title>Reset your password</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon>
            <v-icon @click="forgotDialogCancel">cancel</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          An email has been sent to {{ email }}
          <br />
          Please follow the instructions and use the new password above
        </v-card-text>
      </v-card>

      <v-card v-if="showLinkDialog">
        <v-toolbar light color="accent">
          <v-toolbar-title>Link accounts</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon>
            <v-icon @click="userLinkCancel">cancel</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          You already have an account for {{ Controls.email }} using {{ Controls.service }}
          <br />
          You can link it with {{ Controls.newService }} so you can use either to login in future
          <div v-if="showPasswordDialog">
            You'll need to provide your filmID password above to allow this
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            @click="userLinkComplete"
            :disabled="loginDisabled"
            >
          Link accounts
          </v-btn>
        </v-card-actions>
      </v-card>

    </v-flex>
  </v-layout>
</v-container>
   
    </template>
  </splash>
</template>

<script>

import buttonGoogle from '@/assets/buttongoogle.svg'
import buttonGithub from '@/assets/buttongithub.png'
import buttonTwitter from '@/assets/buttontwitter.png'
import Splash from '@/components/Splash'
import { Controls } from '@/gql'
import { mergeControls } from '@/js/apollo'
export default {
  name: 'Login',
  components: {
    splash: Splash
  },
  props: {
    auth: Object
  },
  computed: {
    loginDisabled () {
      return !(/.+@.+/.test(this.email) && this.password.length > 5)
    },
    forgotDisabled () {
      return this.showForgotDialog || (!(/.+@.+/.test(this.email)))
    },
    showForgotDialog () {
      return this.Controls && this.Controls.showForgotDialog
    },
    showLinkDialog () {
      return this.Controls && this.Controls.showLinkDialog
    },
    showPasswordDialog () {
      return this.Controls && this.Controls.showPasswordDialog
    }
  },
  data () {
    return {
      email: '',
      password: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+/.test(v) || 'E-mail must be valid'
      ],
      buttonGoogle,
      buttonGithub,
      buttonTwitter,
      Controls: {}
    }
  },
  methods: {
    signup () {
    },
    goBack () {
      this.$router.replace({ path: this.Controls.routerFrom })
    },
    async forgotPassword () {
      await this.$auth.forgotPassword({
        email: this.email
      })
    },
    loginClick () {
      return this.$auth.login({
        service: 'password',
        email: this.email,
        password: this.password
      }).then(() => {
        this.clearShows()
        return this.goBack()
      })
    },
    loginTwitter () {
      this.loginProvider('twitter')
    },
    loginGoogle () {
      this.loginProvider('google')
    },
    loginGithub () {
      this.loginProvider('github')
    },
    async loginProvider (service) {
      await this.$auth.login({
        service
      })
      return this.goBack()
    },
    cancelClick () {
      this.clearShows()
      this.goBack()
    },
    forgotDialogCancel () {
      this.clearShows()
    },
    clearShows () {
      mergeControls({
        showPasswordDialog: false,
        showLinkDialog: false,
        showForgotDialog: false
      })
    },
    async userLinkComplete () {
      await this.$auth.userLinkComplete({ service: this.Controls.service, email: this.email, password: this.password })
      this.clearShows()
    },
    userLinkCancel () {
      this.clearShows()
      this.goBack()
    }
  },
  apollo: {
    Controls: {
      query: Controls
    }
  }
}
</script>
